import { useRightPanel } from '@/containers/SubscriptionFormPageNew/Components/shared/RightPanel/rightPanelContext'

const useModuleCollapse = (moduleKey: string) => {
  const { expanded, unfoldedModules, toggleModule } = useRightPanel()

  return {
    expanded: expanded && unfoldedModules.has(moduleKey),
    toggle: () => toggleModule(moduleKey),
    panelExpanded: expanded,
  }
}

export default useModuleCollapse
